import axios from 'axios'
import config from '../config/dev.json'

let path = '/api/v1'
let url = config.host + path
let urlSecure = config.host + path +'/contacter'
import production from '../config/production.json'


if (process.env.NODE_ENV === 'production') {
  url = production.host + path + '/contacter'
}
export async function contactMessage(contact) {

  console.log("############# test contact #################", contact)
    return new Promise((resolve, reject) => {
        console.log("je suis dans le service contact", contact)
      axios.post(urlSecure + '/add', contact).then((response) => {
        console.log("je suis dans le service response.data.data.contact", response.data.data)

        let contact = response.data.data
        resolve(contact)
      }).catch(err => reject(err))
    })
  }





// WEBPACK FOOTER //
// ./src/api/contact.service.js